'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$0024anon$0024156 from "./presto.types$$anon$156.js";
import * as $j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$002dEmail$002dPayload$0024 from "./presto.types$-Two-Factor-Auth-Email-Payload$.js";
var $p;
/** @constructor */
function $c_Lpresto_types$TwoFactorAuthPayload$$anon$155() {
  this.ccv = null;
  this.ccn = null;
  this.cco = false;
  this.ccw = null;
  this.ccx = false;
  this.ccA = null;
  this.cct = null;
  this.ccu = false;
  this.ccp = null;
  this.ccq = false;
  this.ccr = null;
  this.ccs = false;
  this.ccy = false;
  this.ccz = false;
  this.ccv = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.ccA = "TwoFactorAuthEmailPayload";
}
export { $c_Lpresto_types$TwoFactorAuthPayload$$anon$155 as $c_Lpresto_types$TwoFactorAuthPayload$$anon$155 };
$p = $c_Lpresto_types$TwoFactorAuthPayload$$anon$155.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$TwoFactorAuthPayload$$anon$155;
/** @constructor */
function $h_Lpresto_types$TwoFactorAuthPayload$$anon$155() {
}
export { $h_Lpresto_types$TwoFactorAuthPayload$$anon$155 as $h_Lpresto_types$TwoFactorAuthPayload$$anon$155 };
$h_Lpresto_types$TwoFactorAuthPayload$$anon$155.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.ccv;
});
$p.L = (function() {
  if ((!this.cco)) {
    this.ccn = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.cco = true;
  }
  return this.ccn;
});
$p.O = (function() {
  if ((!this.ccx)) {
    this.ccw = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.ccx = true;
  }
  return this.ccw;
});
$p.E = (function() {
  return this.ccA;
});
$p.t = (function() {
  if ((!this.ccu)) {
    this.cct = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("email", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.ccu = true;
  }
  return this.cct;
});
$p.M = (function() {
  if ((!this.ccq)) {
    this.ccp = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().aa, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.ccq = true;
  }
  return this.ccp;
});
$p.Q = (function() {
  if ((!this.ccs)) {
    this.ccr = new $j_presto$002etypes$0024$0024anon$0024156.$c_Lpresto_types$$anon$156();
    this.ccs = true;
  }
  return this.ccr;
});
$p.w = (function() {
  if ((!this.ccz)) {
    this.ccy = false;
    this.ccz = true;
  }
  return this.ccy;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee167) => ((p) => \u03b4scrutinee167.cGz(p)))($j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$002dEmail$002dPayload$0024.$m_Lpresto_types$TwoFactorAuthEmailPayload$())));
});
var $d_Lpresto_types$TwoFactorAuthPayload$$anon$155 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$TwoFactorAuthPayload$$anon$155, "presto.types$TwoFactorAuthPayload$$anon$155", ({
  a2l: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_types$TwoFactorAuthPayload$$anon$155 as $d_Lpresto_types$TwoFactorAuthPayload$$anon$155 };
//# sourceMappingURL=presto.types$-Two-Factor-Auth-Payload$$anon$155.js.map
